import { keyBuilder } from "@/helpers/keyBuilder"
import { useNormalizeConfiguration } from "@/hooks/useNormalizeConfiguration"
import { useCallback } from "react"

export const useKeyBuilder = () => {
  const normalize = useNormalizeConfiguration()

  return useCallback(params => keyBuilder(normalize(params)), [normalize])
}
